module.exports = __webpack_public_path__ + "static/img/12.715ee10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/zh/12.png
// module id = jllr
// module chunks = 0